import { render, staticRenderFns } from "./FreelancerFeatures.vue?vue&type=template&id=027a8eee"
import script from "./FreelancerFeatures.vue?vue&type=script&lang=ts"
export * from "./FreelancerFeatures.vue?vue&type=script&lang=ts"
import style0 from "./FreelancerFeatures.vue?vue&type=style&index=0&id=027a8eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports